/**
 * asc_added: 追加日(昇順)
 * desc_added: 追加日(降順)
 * asc_opened: 公開日(昇順)
 * desc_opened: 公開日(降順)
 * by_duration: 上映時間順
 */
export const PLAY_LIST_VIDEO_SORT_LIST = [
  'desc_added',
  'asc_added',
  'desc_opened',
  'asc_opened',
  'by_duration',
] as const

export type PlayListVideoSortType = typeof PLAY_LIST_VIDEO_SORT_LIST[number]

export const PLAY_LIST_VIDEO_SORT_LOCAL_STORAGE_KEY = 'play_list_video_sort_local_storage_key'
